import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Zone} from 'src/app/zone/zone';
import {Page} from '../../core/pagination/page';
import {PageRequest} from '../../core/pagination/page-request';
import {SortOrder} from '../../core/sort/sort-order';
import {Thuisverzorger} from '../thuisverzorger';
import {Diensten} from '../../dienst/diensten';

@Component({
    selector: 'zah-thuisverzorgers',
    templateUrl: './thuisverzorgers.component.html',
    styleUrls: ['./thuisverzorgers.component.scss'],
    standalone: false
})
export class ThuisverzorgersComponent implements OnInit {

  @Input()
  initialPageRequest: PageRequest<Thuisverzorger>;
  @Input()
  thuisverzorgersPage: Page<Thuisverzorger>;
  @Input()
  zones: Array<Zone>;
  @Input()
  diensten: Diensten;
  @Output()
  thuisverzorgerClicked: EventEmitter<Thuisverzorger> = new EventEmitter<Thuisverzorger>();
  @Output()
  deleteClicked: EventEmitter<Thuisverzorger> = new EventEmitter<Thuisverzorger>();
  @Output()
  addClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  pageChange: EventEmitter<PageRequest<Thuisverzorger>> = new EventEmitter<PageRequest<Thuisverzorger>>();

  private currentPageRequest: PageRequest<Thuisverzorger>;

  ngOnInit(): void {
    this.currentPageRequest = this.initialPageRequest;
  }

  onThuisverzorgerClick(thuisverzorger: Thuisverzorger): void {
    this.thuisverzorgerClicked.emit(thuisverzorger);
  }

  onDeleteClick(thuisverzorger: Thuisverzorger): void {
    this.deleteClicked.emit(thuisverzorger);
  }

  onAddClick(): void {
    this.addClicked.emit();
  }

  onSortOrderChange(sortOrder: SortOrder): void {
    this.currentPageRequest = PageRequest.firstPageRequest<Thuisverzorger>(sortOrder, this.currentPageRequest.getPageSize());
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageSizeChange(pageSize: number): void {
    this.currentPageRequest = PageRequest.firstPageRequest<Thuisverzorger>(this.currentPageRequest.getSortOrder(), pageSize);
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageChange(pageRequest: PageRequest<Thuisverzorger>): void {
    this.currentPageRequest = pageRequest;
    this.pageChange.emit(pageRequest);
  }
}
